module.exports = __webpack_public_path__ + "media/puls.4dbe0217.mp4";